import PropTypes from 'prop-types';
import Joi from 'joi';
import Form from '../../common/form';
import toastService from '../../../services/toastService';

const DEFAULT_TECHNOLOGY_INTRODUCTION = 'Pulsed Eddy Current (PEC) is a method to measure thickness of carbon and low-alloyed steel without the need to make contact between probe and steel surface. PEC uses a strong magnetic field that penetrates through thick external protection. PEC has been applied to inspect coated or insulated or concreate  steel. This is a screen tool and not to be used for accurate measurement';

class CustomTechnologyIntroductionForm extends Form {
	state: any = {
		data: { technologyIntroduction: DEFAULT_TECHNOLOGY_INTRODUCTION },
		errors: {},
		loading: false,
		touched: false,
		progress: 0,
	};

	static propTypes = {
		initialTecnologyIntroduction: PropTypes.string,
	};

	schema = {
		technologyIntroduction: Joi.string()
			.optional()
			.label('Technology Introduction'),
	};

	componentDidMount() {
		if (this.props.initialTecnologyIntroduction) {
			this.setState({ data: { technologyIntroduction: this.props.initialTecnologyIntroduction }});
		}
	}

	doSubmit = () => {
		this.props.onSave(this.state.data.technologyIntroduction);
		toastService.success('Saved successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="form-title">Technology Introduction</div>
				
				<div className="my-4 divider"></div>

				{this.renderTextArea({
					name: 'technologyIntroduction',
					label: '',
					rows: '4',
					placeholder: 'Enter Technology Introduction',
				})}

				<div className="mt-4 mb-2 divider"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save')}
				</div>
			</form>
		);
	}
}

export default CustomTechnologyIntroductionForm;
